<template>
  <div class="box">
    <div class="d-flex align-items-center mb-2">
      <div class="d-flex">
        <span class="my-input-container">
          <input
            :class="error && 'is-danger'"
            v-model="startTimeMins"
            placeholder="01"
            id="Field8-1" name="Field8-1" type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
        </span>
        <span class="my-time-divider">:</span>
        <span class="my-input-container">
          <input
            v-model="startTimeSecs"
            placeholder="21"
            :class="error && 'is-danger'"
            id="Field8-2" name="Field8-2" type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
        </span>
      </div>
      <div class="time-divider"></div>
      <div class="d-flex">
        <span class="my-input-container">
          <input
            v-model="endTimeMins"
            placeholder="09"
            :class="error && 'is-danger'"
            id="Field8-1" name="Field8-1" type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
        </span>
        <span class="my-time-divider">:</span>
        <span class="my-input-container">
         <input
          v-model="endTimeSecs"
          placeholder="57"
          :class="error && 'is-danger'"
          id="Field8-2" name="Field8-2" type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
        </span>
      </div>
    </div>

    <div class="select mb-4">
      <select v-model="dimension">
        <option v-for="dim in dimensions">{{ dim }}</option>
      </select>
    </div>
    <MultiAnswer
      :ta1.sync="data.ta1"
      :ta2.sync="data.ta2"
      :ta3.sync="data.ta3"
      />
    <div class="bottom">
      <button class="button is-info mb-2" @click="save">Save</button>
      <button class="button is-danger mb-2 mr-2" @click="$emit('close')">Cancel</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import store from '../store.js'

import MultiAnswer from './MultiAnswer.vue'
import PlayIcon from './PlayIcon.vue'

import { prettyTimeStamp } from '../filters.js'
import { minsSecondsToSeconds, secsToMinsandSecs } from '../time.js'

export default {
  name: 'CreateArtFormComment',
  components: {
    MultiAnswer,
    PlayIcon
  },
  props: {
    videoID: {
      type: Number,
      required: true,
    },
    currentTime: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      error: false,
      dimension: null,
      startTimeMins: null,
      startTimeSecs: null,
      endTimeMins: null,
      endTimeSecs: null,
      val: '',
      loading: true,
      query: '',
      dimensions: [
        'Student Engagement',
        'Authentic and engaging work in the art form',
        'Classroom climate and routines that create a safe and productive working environment',
        'Opportunities to express personal ideas and experiences creatively',
        'Clear and high expectations and levels of challenge',
        'Peer-to-peer collaboration with mutual respect',
        'Guidance and assessment practices that help students develop skills as well as original visions and voices',
        'Inclusion and support for all learners to produce excellent work',
        'Culturally responsive arts learning reflective of Boston’s ethnic, economic and linguistic demographics',
        'Other observations and questions you have about the quality of teaching and learning in this class',
        'Other questions you want to ask'
      ],
      data: {
        ta1: null,
        ta2: null,
        ta3: null,
      }
    }
  },
  mounted () {
    const [ startTimeMins, startTimeSecs ] = secsToMinsandSecs(this.currentTime)
    const [ endTimeMins, endTimeSecs ] = secsToMinsandSecs(this.currentTime + 20)

    this.dimension = this.dimensions[0]

    this.startTimeMins = startTimeMins
    this.startTimeSecs = startTimeSecs
    this.endTimeMins = endTimeMins
    this.endTimeSecs = endTimeSecs
    this.loading = false
  },
  computed: {
    user () {
      return store.state.user
    },
  },
  methods: {
    prettyTimeStamp,
    save (showToast = false) {
      const {
        endTimeSecs,
        endTimeMins,
        startTimeSecs,
        startTimeMins
      } = this

      const fieldsNotEmpty =
        startTimeMins !== '' && endTimeMins !== '' &&
        startTimeSecs !== '' && endTimeSecs !== '' &&
        this.data.ta1 !== '' && this.data.ta2 !== '' && this.data.ta3 !== ''

      const endTime = minsSecondsToSeconds([endTimeMins, endTimeSecs])
      const startTime = minsSecondsToSeconds([startTimeMins, startTimeSecs])

      const reqData = {
        video: this.videoID,
        end_time: endTime,
        start_time: startTime,
        user: this.user.id,
        text_see: this.data.ta1,
        text_notice: this.data.ta2,
        text_wonder: this.data.ta3,
        dimension: this.dimension,
      }

      if (fieldsNotEmpty) {
        return axios.post('/api/v1/artformcomments/', reqData,
          { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } })
        .then(response => {
          if (showToast) {
            store.commit('notify', { message: 'Saved successfully', level: 'info' })
          }
          console.log('saved...')
          store.state.artformcomments.push(response.data)

          this.data.ta1 = ''
          this.data.ta2 = ''
          this.data.ta3 = ''
          this.$emit('close')
        })
        .catch(error => store.dispatch(store.action.generalErrorHandler, { error, message: "Uh Oh. It couldn't save." }))
      }
    },
  },
}

</script>

<style lang="scss" scoped>

@import '../_variables.scss';

.box {
  border: 3px solid $teal;
}

.top {
  display: flex;
  align-items: center;
  justify-content: center;
}

.bottom {
  display: flex;
  flex-direction:row-reverse;
}

.time-divider {
  width: 1rem;
  height: 3px;
  border-radius: 4px;
  background-color: gray;
  margin: 5px;
}

.my-input-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.my-input {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  box-shadow: none;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
}

</style>



// WEBPACK FOOTER //
// CreateArtFormComment.vue?74c62a01